import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import AuthPanel from "../components/AuthPanel";
import { loginUser } from "../utils/APIConnector/APIConnector";
import { setRefreshToken } from "../session/TokenStore";

import styles from "./pages.module.css";

export default function Login() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const api = {
        onLogin: async ({ username, password }) => {
            await loginUser(username, password).then(data => {
                if (data && data.refresh) {
                    setRefreshToken(data.refresh);
                } else {
                    throw new Error("No refresh token received");
                }
                navigate("/create-survey");
            });
        },
    };

    return (
        <PageLayout>
            <section className={styles.section}>
                <h2 className={styles.title}>{t("header.login")}</h2>
                <AuthPanel onLogin={api.onLogin} />
            </section>
        </PageLayout>
    );
}